import { render, staticRenderFns } from "./Me.vue?vue&type=template&id=1e989630&scoped=true&"
import script from "./Me.vue?vue&type=script&lang=ts&"
export * from "./Me.vue?vue&type=script&lang=ts&"
import style0 from "./Me.vue?vue&type=style&index=0&id=1e989630&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e989630",
  null
  
)

export default component.exports